// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comp-layouts-header[data-v-bc51760e]{align-items:center;display:flex;justify-content:space-between;padding:5px 25px 5px 15px;width:100%}.comp-layouts-header .icon-menu[data-v-bc51760e]{cursor:pointer;margin-right:15px;padding:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
